export enum ConfigLanguageCodeEnum {
  en = 'en',
  ar = 'ar',
  fr = 'fr',
  arGb = 'arGb',
}
